// used to provide the selected shop to all components
export const selectedShopKey = Symbol();
// used to provide the shops/sites list to all components
export const sitesKey = Symbol();

export const userKey = Symbol();
